import { queryCludo, QueryCludoRequestInterface } from '3-foundation/Search/connector';

export const defaultNewsLimit = 12;

export const getNews = async ({
	filters,
	limit,
	locale,
	siteId,
}: QueryCludoRequestInterface): Promise<{
	items: Content.NewsCatalogPageProperties['newsItems'];
	tags: Content.NewsCatalogPageProperties['filterTags'];
	totalItems: Content.NewsCatalogPageProperties['totalNewsItems'];
}> => {
	const searchResult = await queryCludo({
		filters: { ...filters, pageType: 'newsPage' },
		limit: limit ? limit : defaultNewsLimit,
		sort: { 'search-sort': 'desc' },
		locale,
		siteId,
	});
	const { TypedDocuments: items, Facets, TotalDocument } = searchResult ?? {};
	const facets = Facets?.Category?.Items ?? [];
	const newsItems = items?.map((item) => {
		return {
			date: item?.Fields?.['search-date']?.Value,
			image: item?.Fields?.['search-image-url']?.Value ? { url: item?.Fields?.['search-image-url']?.Value, altText: '' } : null,
			link: item?.Fields?.Url?.Value ? { url: item.Fields.Url.Value, name: '' } : null,
			teaser: item?.Fields?.['search-rte-teaser']?.Value || null,
			title: item?.Fields?.['search-title']?.Value,
		};
	});

	const tags = facets
		?.map((tag) => {
			return { name: tag.Key, count: tag.Count };
		})
		.filter((tag) => tag.name !== 'Other');
	return { items: newsItems, tags, totalItems: TotalDocument };
};
